import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App'
import './style.css'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://36b1c86e04222f836087492ac7d6e9e3@o4510452164591616.ingest.us.sentry.io/4510452166819840",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.captureConsoleIntegration({ levels: ["error"] }), Sentry.httpClientIntegration()],
  enabled: !import.meta.env.DEV
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
